/* eslint-disable @typescript-eslint/naming-convention */
import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

export const APP_HOSTNAME: DiToken<string> = new DiToken<string>('appHostname');

/** Origin of the incoming request, with a trailing slash (e.g. `https://januszcasino.com/`). */
export const APP_BASE_URL: DiToken<string> = new DiToken<string>('appBaseUrl');

export const APP_RELEASE_VERSION: DiToken<string> = new DiToken<string>('appReleaseVersion', {
  factory: () => '0'
});
